export type AskAiAgent = 'vision' | 'quality';

export function getAgentForPathname(pathname: string): AskAiAgent | null {
  if (pathname.startsWith('/monitor')) {
    return 'quality';
  }
  if (pathname.startsWith('/quality-agent')) {
    return null;
  }
  return 'vision';
}

export const ACCENT_HOVER = '#07B4DB';

export const ASK_AI_PANEL_Z_INDEX = 9999;

export const ASK_AI_PANEL_MENU_Z_INDEX = ASK_AI_PANEL_Z_INDEX + 1;

export const ABOVE_ASK_AI_PANEL_Z_INDEX = ASK_AI_PANEL_MENU_Z_INDEX + 1;

export const AGENT_TILE_GRADIENT: Record<AskAiAgent, string> = {
  vision: 'linear-gradient(135deg, #0B93E8 0%, #09D3FD 100%)',
  quality: 'linear-gradient(135deg, #FC098F 0%, #EF6AC6 100%)',
};

export const AGENT_PANEL_GLOW: Record<AskAiAgent, string> = {
  vision:
    'radial-gradient(520px 260px at 0% 0%, rgba(9, 211, 253, 0.4) 0%, rgba(123, 232, 255, 0.26) 35%, rgba(255, 255, 255, 0) 100%)',
  quality:
    'radial-gradient(520px 260px at 0% 0%, rgba(252, 9, 143, 0.4) 0%, rgba(239, 106, 198, 0.26) 35%, rgba(255, 255, 255, 0) 100%)',
};
